import { FC, PropsWithChildren } from 'react';
import cn from 'classnames';

import SystemNotificationsContainer from 'common/components/SystemNotificationsContainer';
import createGlobalApp from 'common/apps/apps/global';
import App from 'common/apps/core/App';
import Notifications from 'common/apps/modules/notifications/Notifications';
import useApp from 'common/helpers/useApp';
import {
  GlobalApiContext,
  GlobalStateContext,
} from 'common/apps/core/contexts';
import { GlobalAppType } from 'common/apps/apps/global/types';

import styles from './styles.module.css';

const globalContexts = { state: GlobalStateContext, api: GlobalApiContext };

type SimpleLayoutProps = PropsWithChildren<{ isColumns?: boolean }>;

const SimpleLayout: FC<SimpleLayoutProps> = ({
  children,
  isColumns = false,
}) => (
  <div>
    <App
      app={useApp(createGlobalApp, GlobalAppType.SimpleLogin)!}
      contexts={globalContexts}
    >
      <Notifications />
    </App>
    <SystemNotificationsContainer />
    <div
      className={cn(styles.simpleLayout, {
        [styles.simpleLayoutColumns]: isColumns,
      })}
    >
      {children}
    </div>
  </div>
);

export default SimpleLayout;
